module.exports = __webpack_public_path__ + "static/media/testimonials-mariane.0aea9495.png";